import { Field, ObjectType } from "./decorators";



export enum InterfaceNameType {
  PayNowWithCredit = 'PayNowWithCredit',
  PayMultipleInvoices = 'PayMultipleInvoices',
  AddAch = 'AddAch',
  ModifyAch = 'ModifyAch',
  DeleteAch = 'DeleteAch',
  leaseShortCodeV1 = 'leaseShortCodeV1',
  monthEndReport = 'monthEndReport',
  VetResults = 'Vet Results',
  VetRequest = 'VetRequest'
}

export enum ExternalInterfaceType {
  NsRestlet = 'NsRestlet',
  RegistrantApi = 'RegistrantApi',
  VmApi = 'VmApi',
  Soap = 'Soap'
}

export enum MethodType {
  Post = 'POST',
  Get = 'GET'
}

export enum InterfaceActivityLogStatusType {
  Success = 'success',
  Fail = 'fail'
}

@ObjectType()
export class InterfaceActivity {

  @Field({q:['sdlist']})
  requestId!: number;

  @Field({q:['sdlist']})
  public requestDateTime!: Date;

  @Field()
  public responseDateTime?: Date;

  @Field()
  public duration?: number;

  @Field({q:['sdlist']})
  public interfaceName!: InterfaceNameType;

  @Field({q:['sdlist']})
  public externalInterface!: ExternalInterfaceType;
  
  @Field()
  public method!: MethodType;

  @Field()
  public user?: string;

  @Field({q:['sdlist']})
  public accountId?: number;
  
  @Field({q:['sdlist']})
  public status!: InterfaceActivityLogStatusType;

  @Field()
  public errorCode?: string;

  @Field()
  public errorMessage?: string;

  @Field()
  public params?: string;

  @Field()
  public httpStatus?: number;

  @Field()
  public request?: string;

  @Field()
  public response?: string;

  @Field({q:['sdlist']})
  public logLink?: string;

}
